module.exports = __webpack_public_path__ + "img/appTeaser.997a8b86.png";